import React, { useCallback } from "react";
import { FieldProps } from "react-jsonschema-form";
import InputGroup from "../../witadmin/CRUD/Common/InputGroup";
import styled from "styled-components";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import SelectGroup from "../../witadmin/CRUD/Common/SelectGroup";
import { WitLabel } from "./common";

const messages = defineMessages({
  amount: {
    id: "loyaltyTier.amount",
    defaultMessage: "amount",
  },
  type: {
    id: "loyaltyTier.type",
    defaultMessage: "amount",
  },
  constant: {
    id: "loyaltyTier.constant",
    defaultMessage: "constant",
  },
  percentage: {
    id: "loyaltyTier.percentage",
    defaultMessage: "percentage",
  },
});

const SelectGroupWrapper = styled.div`
  width: 200px;
`;

export function AmountType({ formData, onChange, schema }: FieldProps) {
  const intl = useIntl();
  const handleChangeAmount = useCallback(
    data => {
      onChange({
        ...formData,
        amount:
       Number(data.event.target.value),
      });
    },
    [formData, onChange]
  );
  const handleChangeType = useCallback(
    (event, field) => {
      onChange({
        ...formData,
        type: +event.target.value,
      });
    },
    [formData, onChange]
  );
  return (
    <>
      <WitLabel>{schema?.title}</WitLabel>
      <div>
        <label>
          <FormattedMessage {...messages.amount} />
        </label>
        <InputGroup
          type="number"
          value={formData.amount}
          field={{ fieldName: "amount" }}
          onChange={data => handleChangeAmount(data)}
          disabled={false}
          readOnly={false}
        />
      </div>
      <div>
        <label>
          <FormattedMessage {...messages.type} />
        </label>
        <SelectGroupWrapper>
          <SelectGroup
            value={formData.type}
            field={{
              fieldName: "type",
              widget: "selector",
              optionDisplay: {
                0: { label: intl.formatMessage(messages.percentage) },
                1: { label: intl.formatMessage(messages.constant) },
              },
            }}
            onChange={({ event, field }) => handleChangeType(event, field)}
            errors={undefined}
            additionalFields={undefined}
            className={undefined}
          />
        </SelectGroupWrapper>
      </div>
    </>
  );
}
